var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-confirm",attrs:{"role":"alertdialog","aria-label":_vm.title}},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2),_c('span',{staticClass:"ui-actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }